<template>
  <div class="upload">
    <el-upload
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :file-list="fileList"
      :action="domain"
      :on-change="fileChange"
      :auto-upload="false"
      :multiple="true"
    >
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import { uploadPic } from "../service";
export default {
  props: {
    fatherMethod: {
      type: Function,
      default: null
    },
    singleImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allUpload: false,
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      token: {},
      // 七牛云的上传地址，根据自己所在地区选择，我这里是华南区
      domain: "https://api.onesb2c.com"
    };
  },
  methods: {
    // 上传文件到服务器（自定义上传）
    uploadImage() {
      const config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      // formdata
      let formdata = new FormData();
      this.fileList.forEach(file => {
        formdata.append("file", file.raw);
      });
      // 请求上传图片接口
      this.axios.post("/api/upload/pic", formdata, config).then(res => {
        if (res.data.code === 0) {
          this.fileList = [];
          // 向父组件传递上传的图片结果
          this.$emit("ImageRes", res);
          // 当图片上传成功后,调用父组件事件
          this.fatherMethod(res.data.result[0].relativeUrl);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handlePictureCardPreview(file) {
      //放大图片
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //检测文件变动获取文件
    fileChange(file, fileList) {
      this.fileList = fileList;
      // 是否只准上传一个图片
      if (this.singleImg) {
        if (this.fileList.length >= 1) {
          document.querySelector(
            ".el-upload.el-upload--picture-card"
          ).style.display = "none";
        }
      }
    },
    // 删除
    handleRemove(file, fileList) {
      this.fileList = fileList;
      // 是否只准上传一个图片
      if (this.singleImg) {
        if (this.fileList.length < 1) {
          setTimeout(function() {
            document.querySelector(
              ".el-upload.el-upload--picture-card"
            ).style.display = "block";
          }, 500);
        }
      }
    },
    SubmitImages() {
      //图片统一上传
      // this.uploadImage();
      // this.fatherMethod();
    }
  },
  mounted() {
    this.$on("bridge", val => {
      this.uploadImage();
    });
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-upload.el-upload--picture-card {
  width: 68px;
  height: 68px;
  position: relative;
}
/deep/ .el-icon-plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/deep/ .el-upload-list__item.is-ready {
  width: 68px;
  height: 68px;
  img {
    width: 100%;
    height: 100%;
    vertical-align: bottom;
  }
}
</style>